import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { BasePage } from 'src/pages/base.page';
import { LoginViewModel } from 'src/pages/login/LoginViewModel';
import { AlertComponent } from 'projects/core/src/lib/core/Alert.component';
import { AlertController, LoadingController, ToastController, MenuController } from '@ionic/angular';

import { LoadingComponent } from 'projects/core/src/lib/core/Loading.component';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { LoginModel } from 'projects/core/src/lib/core/model/LoginModel';
import { MaskCPF } from 'projects/core/src/lib/core/MaksCPF'
import { MessageService } from 'projects/core/src/lib/core/MessageService';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';

import { AppSession } from '../../../projects/core/src/lib/core/AppSession'
@Component({
  selector: 'login-page',
  templateUrl: 'login.page.html',
  styleUrls: ['login.page.scss']
})
export class LoginPage extends BasePage {
  constructor(private googleAnalyticsService: GoogleAnalyticsService,
    public router: Router,
    private alertController: AlertController,
    private loadingController: LoadingController,
    public toastCtrl: ToastController,
    public menuCtrl: MenuController) {
    super(router)
  }

  alertComponent: AlertComponent
  loadingComponent: LoadingComponent
  loginModel: LoginModel
  loginViewModel: LoginViewModel

  ngOnInit() {
    this.iniciaVariaveis()
    this.menuCtrl.enable(false)
    this.preparaLogin()
    this.configuraTeclado()

    let element: any = document.getElementById("campoUsuario")

    element.addEventListener("keydown", (e) => {
      setTimeout(() => {
        let v: any = e.target
        let valor = this.loginViewModel.mascaraCpfEmail(v.value)
        element.value = valor
      }, 100)
    })
  }

  configuraTeclado() {
    let html = document.getElementsByTagName("html")[0];
    window.addEventListener('native.keyboardshow', (e) => {
      console.log("show2");
      html.style.height = "auto";
      //this.renderer2.setStyle(html, 'height', '101vh');
    });
    window.addEventListener('native.keyboardhide', () => {
      console.log("hide2");
      html.style.height = "101vh";
      //this.renderer2.setStyle(html, 'height', 'auto');
    });
  }

  formataCampoUsuario() {
    let usuario = this.loginViewModel.mascaraCpfEmail(this.loginModel.usuario)
    this.loginModel.usuario = usuario
  }

  async preparaLogin() {
    let ultimoLogin: any = await this.loginViewModel.obtemUltimoLogin()
    if (ultimoLogin && ultimoLogin.usuario) {
      this.loginModel.usuario = this.loginViewModel.mascaraCpfEmail(ultimoLogin.usuario)
    }
  }

  formatCPF(value) {
    this.loginModel.usuario = new MaskCPF().format(this.loginModel.usuario)
  }

  iniciaVariaveis() {
    this.loginModel = new LoginModel()
    this.loginViewModel = new LoginViewModel()
    this.loginViewModel.setContext(this)
    this.loadingComponent = new LoadingComponent(this.loadingController)
  }

  async autenticaUsuario() {
    const loading = await this.showLoading()
    try {
      this.googleAnalyticsService.logEvent('acesso_login')
      await this.loginViewModel.processoLogin(this.loginModel)
    } catch (e) {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, e.message)
    }
    if (loading != null) {
      loading.dismiss()
    }
  }

  async processoUsuarioAutenticado() {
    await this.loginViewModel.setupApp().then( async () => {
      this.openPage('/navigation/home')
      let userInApp = await AppSession.getUser()
      this.googleAnalyticsService.setUserId(userInApp.id)
      this.googleAnalyticsService.setUserProperty(
        'pagante', `${userInApp.pagante ? 'Sim' : 'Nao'}`
      )
      setTimeout(() => {
        MessageService.sendMessage(MessageService.KEY_LOGIN)
      }, 500)
    }).catch(() => {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'Não foi possível carregar as informações base do app. Tente novamente ou entre em contato conosco')
    })
  }

  async showLoading() {
    return await this.loadingComponent.showLoading()
  }

  validaUsuarioESenha() {
    this.loginModel.usuario = this.loginModel.usuario.trim()

    if (!this.loginModel.usuario || this.loginModel.usuario == '') {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'É necessário preencher o campo "CPF ou e-mail"')
      return false;
    }

    if (!this.loginViewModel.validaUsuario(this.loginModel)) {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'Informe um CPF ou e-mail válido')
      return false;
    }

    if (!this.loginModel.senha || this.loginModel.senha == '') {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'É necessário preencher o campo "senha"')
      return false;
    }
    return true
  }

  btnCriarConta() {
    this.openPage('cadastro')
  }

  btnEntrar() {
    if (this.validaUsuarioESenha()) {
      this.autenticaUsuario()
    }
  }

  btnRecuperarSenha() {
    this.openPage('/esqueci-minha-senha')
  }
}